module.exports = __webpack_public_path__ + "static/media/sample-drivers.91db6bb0.xlsx";